<div class="container-fluid">
  <h1 class="pageService-title"> الخدمات الالكترونية
  </h1>
  <div class="row">
    <div class="col-md-4">
      <app-service-sidebar></app-service-sidebar>
    </div>
    <div class="col-md-8">
      <div class="content-wrapper">
        <div class="content-header">
          <i class="fa-solid fa-clipboard-list"></i>
          <h2> خدمات تأسيس الشركات </h2>
        </div>
        <div class="row g-4">
          <div class="col-md-6" *ngFor="let item of docsItems">
            <div class="content-card" [routerLink]="['/csr-service']" style="cursor: pointer">
              <div class="green-backdrop"></div>
              <div class="image-box">
                <img [src]="item.image" [alt]="item.title" />
                <div class="overlay">
                  <span>{{ item.title }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>